import Cookies, { CookieAttributes } from 'js-cookie';

const IS_DEV = process.env.VUE_APP_NODE_ENV === 'development';

const cookieOptions: CookieAttributes = {
  sameSite: 'None',
  secure: true,
  domain: IS_DEV ? undefined : '.succesmanagement.nl',
};

export function setCookie(key: string, value: string, options: CookieAttributes = {}): void {
  Cookies.set(key, value, {
    ...cookieOptions,
    expires: 7,
    ...options,
  });
}

export function removeCookie(key: string, options: CookieAttributes = {}): void {
  Cookies.remove(key, {
    ...cookieOptions,
    ...options,
  });
}

export function getCookie(key: string): string | undefined {
  return Cookies.get(key);
}
